module.exports = __webpack_public_path__ + "img/button_news_on.29b5856a.png";